import {SIGNUP_REQUEST, SIGNUP_SUCCESS, SIGNUP_FAILURE} from '../actions';

export const SIGNUP_INITIAL_STATE = {
    isFetching: true,
    error: null
};

const signupReducers = {
    [SIGNUP_REQUEST]: state => ({...state}),
    [SIGNUP_SUCCESS]: (state, {res}) => ({
        ...state,
        ...res,
        isFetching: false
    }),
    [SIGNUP_FAILURE]: (state, {error}) => ({...state, isFetching: false, error})
};

export default function signupUser(state = SIGNUP_INITIAL_STATE, action) {
    let reducer = signupReducers[action.type] || (state => state);
    return reducer(state, action);
}


// WEBPACK FOOTER //
// ./resources/assets/js/reducers/signup.js